import { Controller } from 'stimulus'
import dragula from 'dragula'

export default class extends Controller {
  static targets = ["fieldsList", "addButton", "template"]

  connect() {
    this.initDragula()
    this.reindexPositions()
    this.updateAddButton()
  }

  disconnect() {
    if (this.drake) this.drake.destroy()
  }

  initDragula() {
    if (!this.hasFieldsListTarget) return

    this.drake = dragula([this.fieldsListTarget], {
      moves: (el, source, handle) => {
        return el.classList.contains('nested-field-row')
      }
    })

    this.drake.on('drop', () => {
      this.reindexPositions()
    })
  }

  addField() {
    if (this.getActiveCount() >= 3) return

    const uniqueIndex = Date.now().toString()
    const html = this.templateContent.replace(/NEW_RECORD/g, uniqueIndex)

    this.fieldsListTarget.insertAdjacentHTML('beforeend', html)
    this.reindexPositions()
    this.updateAddButton()
  }

  get templateContent() {
    const template = this.templateTarget
    if (template.content) {
      return template.content.firstElementChild.outerHTML
    }
    return template.innerHTML
  }

  removeField(event) {
    const row = event.target.closest('.nested-field-row')
    const destroyInput = row.querySelector('input[name$="[_destroy]"]')

    if (destroyInput && row.querySelector('input[name*="[id]"]')) {
      destroyInput.value = "1"
      row.style.opacity = "0.5"
      row.style.pointerEvents = "none"
    } else {
      row.remove()
    }

    this.reindexPositions()
    this.updateAddButton()
  }

  reindexPositions() {
    let pos = 1
    const rows = Array.from(this.fieldsListTarget.querySelectorAll('.nested-field-row'))

    rows.forEach(row => {
      const destroyInput = row.querySelector('input[name$="[_destroy]"]')
      if (destroyInput && destroyInput.value === '1') return

      const positionInput = row.querySelector('.position-input')
      if (positionInput) positionInput.value = pos
      pos += 1
    })
  }

  updateAddButton() {
    const count = this.getActiveCount()
    if (this.hasAddButtonTarget) {
      this.addButtonTarget.disabled = count >= 3
      this.addButtonTarget.classList.toggle('disabled', count >= 3)
    }
  }

  getActiveCount() {
    return Array.from(this.fieldsListTarget.querySelectorAll('.nested-field-row'))
      .filter(row => {
        const destroyInput = row.querySelector('input[name$="[_destroy]"]')
        return !destroyInput || destroyInput.value !== '1'
      }).length
  }
}
